export interface OAuthPublicConfig {
  google: boolean
  apple: boolean
  facebook: boolean
  passkey: boolean
}

export function parseOAuthPublicConfig(raw?: string): OAuthPublicConfig {
  if (!raw) return { google: false, apple: false, facebook: false, passkey: false }

  try {
    const parsed = JSON.parse(raw) as Partial<OAuthPublicConfig>
    return {
      google: Boolean(parsed.google),
      apple: Boolean(parsed.apple),
      facebook: Boolean(parsed.facebook),
      passkey: Boolean(parsed.passkey),
    }
  } catch {
    return { google: false, apple: false, facebook: false, passkey: false }
  }
}
